interface Props {
  finalScore: number;
  highScore: number;
  isNewRecord: boolean;
  isPerfect: boolean;
  onReplay: () => void;
}

export const FinalScoreModal = ({ 
  finalScore, 
  highScore, 
  isNewRecord, 
  isPerfect,
  onReplay, 
}: Props) => {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md text-center">
        <h2 className="text-3xl font-bold mb-4">
          {isPerfect ? '🎉 Perfect Run!' : 'Practice Complete!'}
        </h2>
        
        <div className="text-5xl font-bold text-blue-500 mb-2">
          {finalScore.toLocaleString()}
        </div>
        
        {isNewRecord && (
          <div className="text-yellow-500 font-bold mb-4">
            🏆 NEW HIGH SCORE!
          </div>
        )}
        
        <div className="text-gray-600 mb-6">
          High Score: {highScore.toLocaleString()}
        </div>
        
        <div className="flex gap-4">
          <button
            onClick={onReplay}
            className="flex-1 bg-blue-500 text-white py-3 px-6 rounded hover:bg-blue-600"
          >
            Replay
          </button>
        </div>
      </div>
    </div>
  );
};